import { render, staticRenderFns } from "./NavItemFolders.vue?vue&type=template&id=11523e3c&name=nav-item-folders&"
import script from "./NavItemFolders.vue?vue&type=script&lang=js&"
export * from "./NavItemFolders.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports